import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TeCuidamosUserType } from '@core/models/user';
import { ExternalUrlOpenerHelperService } from '@core/services/core/external-url-opener-helper.service';
import { TecuidamosService } from '@core/services/core/tecuidamos.service';
import { FamiliesHelperService } from '@core/services/helpers/families-helper.service';
import { PatrimonialService } from '@core/services/http-services/patrimonial.service';
import { PaymentPlanService } from '@core/services/http-services/payment-plan.service';
import { Platform, PopoverController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  distinctUntilChanged,
  distinctUntilKeyChanged,
  filter,
  map,
  pluck
} from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/core/auth/auth.service';
import { ContextService } from 'src/app/core/services/core/context.service';
import { MenuService } from 'src/app/core/services/core/menu.service';
import { NavigationHelper } from 'src/app/core/services/core/navigation-helper.service';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';

@Component({
  selector: 'mapfre-web-header',
  templateUrl: './mapfre-web-header.component.html',
  styleUrls: ['./mapfre-web-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapfreWebHeaderComponent implements OnInit {

  public profileExpanded$ = new BehaviorSubject<boolean>(false);
  public myProductsSelected$: Observable<boolean>;
  public inFamilySelected$: Observable<boolean>;
  public paymentPlanSelected$: Observable<boolean>;
  public tecuidamosSelected$: Observable<boolean>;

  public userShorthandAvatar = '';

  constructor(
    public platform: Platform,
    public menu: MenuService,
    public ctx: ContextService,
    public auth: AuthService,
    public teCuidamos: TecuidamosService,
    public nav: NavigationHelper,
    public paymentPlanService: PaymentPlanService,
    public patrimonialService: PatrimonialService,
    private popoverController: PopoverController,
    private familiesHelper: FamiliesHelperService,
    private urlExternal: ExternalUrlOpenerHelperService
  ) {}

  ngOnInit() {
    this.myProductsSelected$ = this.ctx.onPageChange$().pipe(
      map(url => url.includes('client-area')),
      distinctUntilChanged()
    );

    this.paymentPlanSelected$ = this.ctx.onPageChange$().pipe(
      map(url => url.includes('payment-plan')),
      distinctUntilChanged()
    );

    this.inFamilySelected$ = this.ctx.onPageChange$().pipe(
      map(url => url.includes('families')),
      distinctUntilChanged()
    );

    this.tecuidamosSelected$ = this.ctx.onPageChange$().pipe(
      map(url => url.includes('tecuidamos')),
      distinctUntilChanged()
    );

    this.auth
      .getState$()
      .pipe(
        pluck('user'),
        filter(user => !!user),
        distinctUntilKeyChanged('documentNumber')
      )
      .subscribe(user => {
        this.userShorthandAvatar = this.menu.getUserShorthand(user);
      });
  }

  onNavToTeCuidamos(memberState: TeCuidamosUserType) {
    this.auth.checkUserIsParticular()
      ? this.teCuidamos.navToTeCuidamos(
          'forward',
          memberState,
          'tecuidamos-header'
        )
      : this.urlExternal.openExternalUrl(
          'https://www.mapfretecuidamos.com/empresas/',
          null,
          null,
          { web: { sameTab: false } }
        );
  }

  async onProfile(ev: Event) {
    this.profileExpanded$.next(true);
    const popover = await this.popoverController.create({
      component: ProfileMenuComponent,
      mode: 'md',
      event: ev,
      cssClass: ['profile-popover'],
      showBackdrop: false,
      keyboardClose: true
    });
    popover.onWillDismiss().then(() => this.profileExpanded$.next(false));
    return await popover.present();
  }

  onOpenFamilies() {
    this.familiesHelper.navToFamilies('forward', 'mapfre-header', false);
  }

  isAllowed(memberState: TeCuidamosUserType) {
    return this.teCuidamos.isAllowed(memberState);
  }
}
